<div role="dialog" aria-labelledby="dialogTitle" >
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"plan.settings.ct.dlg" | translate}}</h4>
    <button [disabled]="!_enableCancel" type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <span class="icon-Close" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>
    <div class="col-16">
      <form (ngSubmit)="submit()">
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
            <label class="text-uppercase input-label" for="startingBacklogInput">
              {{"plan.settings.ct.dlg.starting.backlog" | translate}}
            </label>
          </div>
        </div>
        <div class="row">
          <div class='col-sm-12'>
            <div>
              <input class="form-control wfm-form-control form-control-inline input-wider"
                     name="startingBacklogInput"
                     id="startingBacklogInput"
                     [disabled]="_isLoading"
                     [(ngModel)]="startingBacklog"
                     maxlength="11"
                     (input)="startingBacklogUpdated($event)"
                     (blur)="checkStartingBacklog()"
                     (keydown)="onKeyDown($event)"
                     ngbAutofocus
                     required
                     autocomplete="off"
              > {{"plan.settings.ct.dlg.contacts" | translate}}
              <div *ngIf="_showValidationError" class="error-message">{{'plan.settings.ct.dlg.contacts.validation'|translate}}</div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     [isDisabled]="!_enableCancel"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.submit.btn'|translate}}"
                     id="accept-btn"
                     [isPrimary]="true"
                     [isDisabled]="!_enableAccept"
                     (clicked)="submit()"></breeze-button>
    </div>
  </div>
</div>
